export default function TermsAndConditionsPage() {
  return (
    <div className="bg-[#0A1628] text-white min-h-screen" style={{fontFamily: 'Montserrat, sans-serif'}}>
      {/* Header */}
      <header className="bg-[#1A1A1A] border-b border-[#D4AF37]/20 py-6">
        <div className="max-w-[1200px] mx-auto px-4 md:px-6">
          <div className="flex items-center justify-between">
            <a href="/" className="flex items-center gap-3">
              <img 
                src="https://static.readdy.ai/image/93c3e079cd1f297eadf6098c3b0ef55d/031439dfb7c5b3457d1186c629c535e0.png" 
                alt="Shield Logo"
                className="h-10 w-10 object-contain"
              />
              <span className="text-xl font-bold text-white">Epic Real Estate</span>
            </a>
            <a href="/" className="text-sm text-white/70 hover:text-[#D4AF37] transition-colors whitespace-nowrap">
              Back to Home
            </a>
          </div>
        </div>
      </header>

      {/* Content */}
      <section className="py-16 md:py-24">
        <div className="max-w-[900px] mx-auto px-4 md:px-6">
          <h1 className="text-[40px] md:text-[56px] font-black text-white mb-8" style={{fontFamily: 'Oswald, sans-serif'}}>
            TERMS &amp; CONDITIONS
          </h1>
          
          <div className="space-y-8 text-white/80 leading-relaxed">
            <div>
              <p className="text-sm text-white/60 mb-8">Last Updated: January 2026</p>
              <p className="mb-4">
                Welcome to Epic Real Estate. These Terms and Conditions ("Terms") govern your use of our website and services. By accessing or using our website, you agree to be bound by these Terms. If you do not agree with these Terms, please do not use our website.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-4" style={{fontFamily: 'Oswald, sans-serif'}}>
                1. Acceptance of Terms
              </h2>
              <p>
                By accessing and using this website, you accept and agree to be bound by these Terms and our Privacy Policy. We reserve the right to modify these Terms at any time. Your continued use of the website following any changes constitutes your acceptance of the new Terms.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-4" style={{fontFamily: 'Oswald, sans-serif'}}>
                2. Use of Our Services
              </h2>
              <p className="mb-3">You agree to use our website and services only for lawful purposes. You agree not to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Use the website in any way that violates any applicable federal, state, local, or international law or regulation</li>
                <li>Engage in any conduct that restricts or inhibits anyone's use or enjoyment of the website</li>
                <li>Impersonate or attempt to impersonate Epic Real Estate, an Epic Real Estate employee, another user, or any other person or entity</li>
                <li>Use any robot, spider, or other automatic device to access the website for any purpose without our express written permission</li>
                <li>Introduce any viruses, trojan horses, worms, logic bombs, or other material that is malicious or technologically harmful</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-4" style={{fontFamily: 'Oswald, sans-serif'}}>
                3. Educational Content and Disclaimer
              </h2>
              <p className="mb-3">
                The information provided on this website, including the Gold Dealer Lie Detector checklist, is for educational and informational purposes only. It is not intended as financial, investment, or legal advice.
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>No Financial Advice:</strong> We are not financial advisors, and nothing on this website should be construed as financial advice. You should consult with a qualified financial professional before making any investment decisions.</li>
                <li><strong>No Guarantees:</strong> While we strive to provide accurate and helpful information, we make no representations or warranties about the accuracy, completeness, or suitability of the information provided.</li>
                <li><strong>Your Responsibility:</strong> You are solely responsible for your investment decisions and any consequences that result from those decisions.</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-4" style={{fontFamily: 'Oswald, sans-serif'}}>
                4. Third-Party Relationships
              </h2>
              <p className="mb-3">
                Our website may provide information about or links to third-party gold dealers and service providers. Please note:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>No Endorsement:</strong> References to third-party dealers do not constitute an endorsement or recommendation. We encourage you to conduct your own due diligence.</li>
                <li><strong>Affiliate Relationships:</strong> We may receive compensation from some dealers or partners when you use their services. This does not affect the information we provide or your cost.</li>
                <li><strong>Independent Transactions:</strong> Any transactions you enter into with third-party dealers are solely between you and that dealer. We are not a party to such transactions.</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-4" style={{fontFamily: 'Oswald, sans-serif'}}>
                5. Intellectual Property Rights
              </h2>
              <p className="mb-3">
                The content on this website, including but not limited to text, graphics, logos, images, and software, is the property of Epic Real Estate or its content suppliers and is protected by United States and international copyright laws.
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Limited License:</strong> We grant you a limited, non-exclusive, non-transferable license to access and use our website and download our resources for personal, non-commercial use only.</li>
                <li><strong>Restrictions:</strong> You may not reproduce, distribute, modify, create derivative works of, publicly display, or exploit any of our content without our express written permission.</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-4" style={{fontFamily: 'Oswald, sans-serif'}}>
                6. User-Generated Content
              </h2>
              <p className="mb-3">
                If you submit any content to our website (such as comments, feedback, or testimonials), you grant us a worldwide, non-exclusive, royalty-free license to use, reproduce, modify, and display that content in connection with our business.
              </p>
              <p>
                You represent and warrant that you own or have the necessary rights to any content you submit and that such content does not violate any third-party rights.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-4" style={{fontFamily: 'Oswald, sans-serif'}}>
                7. Limitation of Liability
              </h2>
              <p className="mb-3">
                TO THE FULLEST EXTENT PERMITTED BY LAW, EPIC REAL ESTATE SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR REVENUES, WHETHER INCURRED DIRECTLY OR INDIRECTLY, OR ANY LOSS OF DATA, USE, GOODWILL, OR OTHER INTANGIBLE LOSSES, RESULTING FROM:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Your use or inability to use our website or services</li>
                <li>Any unauthorized access to or use of our servers and/or any personal information stored therein</li>
                <li>Any investment decisions you make based on information obtained through our website</li>
                <li>Any dealings with third-party dealers or service providers</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-4" style={{fontFamily: 'Oswald, sans-serif'}}>
                8. Indemnification
              </h2>
              <p>
                You agree to indemnify, defend, and hold harmless Epic Real Estate and its officers, directors, employees, and agents from and against any claims, liabilities, damages, losses, and expenses, including reasonable attorneys' fees, arising out of or in any way connected with your access to or use of our website or your violation of these Terms.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-4" style={{fontFamily: 'Oswald, sans-serif'}}>
                9. Governing Law and Dispute Resolution
              </h2>
              <p className="mb-3">
                These Terms shall be governed by and construed in accordance with the laws of the United States, without regard to its conflict of law provisions.
              </p>
              <p>
                Any disputes arising out of or relating to these Terms or your use of our website shall be resolved through binding arbitration in accordance with the rules of the American Arbitration Association, except that either party may seek injunctive relief in court to prevent infringement of intellectual property rights.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-4" style={{fontFamily: 'Oswald, sans-serif'}}>
                10. Severability
              </h2>
              <p>
                If any provision of these Terms is found to be unenforceable or invalid, that provision shall be limited or eliminated to the minimum extent necessary so that these Terms shall otherwise remain in full force and effect.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-4" style={{fontFamily: 'Oswald, sans-serif'}}>
                11. Entire Agreement
              </h2>
              <p>
                These Terms, together with our Privacy Policy, constitute the entire agreement between you and Epic Real Estate regarding your use of our website and supersede all prior agreements and understandings.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-4" style={{fontFamily: 'Oswald, sans-serif'}}>
                12. Contact Information
              </h2>
              <p className="mb-3">
                If you have any questions about these Terms and Conditions, please contact us at:
              </p>
              <div className="bg-[#1A1A1A] border border-[#D4AF37]/30 rounded-lg p-6">
                <p className="font-semibold text-white mb-2">Epic Real Estate</p>
                <p>Email: legal@epicrealestate.com</p>
              </div>
            </div>

            <div className="bg-[#FF0000]/10 border-2 border-[#FF0000] rounded-lg p-6 mt-8">
              <p className="text-sm text-white/90 leading-relaxed">
                <strong className="text-[#FF0000]">IMPORTANT:</strong> By using our website and downloading our resources, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions. If you do not agree, please discontinue use of our website immediately.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#0A1628] border-t border-[#D4AF37]/20 py-8 md:py-12">
        <div className="max-w-[1200px] mx-auto px-4 md:px-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 md:gap-0">
            <div className="flex items-center gap-3 md:gap-4">
              <img 
                src="https://static.readdy.ai/image/93c3e079cd1f297eadf6098c3b0ef55d/031439dfb7c5b3457d1186c629c535e0.png" 
                alt="Shield Logo"
                className="h-8 w-8 md:h-10 md:w-10 object-contain"
              />
              <p className="text-xs text-white/70">Epic Real Estate</p>
            </div>

            <div className="flex items-center gap-4 md:gap-8">
              <a href="/privacy-policy" className="text-xs md:text-sm text-white/70 hover:text-[#D4AF37] transition-colors whitespace-nowrap">
                Privacy Policy
              </a>
              <a href="/terms-and-conditions" className="text-xs md:text-sm text-white/70 hover:text-[#D4AF37] transition-colors whitespace-nowrap">
                Terms &amp; Conditions
              </a>
            </div>
          </div>

          <div className="mt-6 md:mt-8 pt-6 md:pt-8 border-t border-white/10 text-center">
            <p className="text-[10px] md:text-xs text-white/50">
              © 2026 Epic Real Estate. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
